import { computed, toValue } from 'vue';
import { SPORT_LIVE_TV_FILTER_GROUPS } from '@/sport-live-tv/constants';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

export const useSportLiveTvFilterGroups = ({ categories, teams, draft }) => {
  const { t } = useSportLiveTvTranslation();

  return computed(() => [
    {
      key: SPORT_LIVE_TV_FILTER_GROUPS.leagues,
      title: t('leagues'),
      searchPlaceholder: t('searchLeagues'),
      options: toValue(categories).map(({ id, name }) => ({ value: String(id), label: name })),
      selected: toValue(draft).leagues.map(String),
    },
    {
      key: SPORT_LIVE_TV_FILTER_GROUPS.teams,
      title: t('teams'),
      searchPlaceholder: t('searchTeams'),
      options: toValue(teams).map((name) => ({ value: name, label: name })),
      selected: toValue(draft).teams,
    },
  ]);
};
